<h2 mat-dialog-title>{{ 'New component' | translate }}</h2>
<mat-dialog-content>

  <div class="cdc-form-field actif" *ngIf="groupsInfo.length > 0">
    <div class="cdc-label">{{ 'Select group' | translate }}</div>
    <mat-form-field class="mt-1 d-flex flex-column select-container component-types">
      <mat-select [(ngModel)]="selectedGroupId">
        <mat-option [value]="'0'">{{ 'Without group' | translate }}</mat-option>
        <mat-option *ngFor="let group of groupsInfo; let i = index" [value]="group.id">{{group.title}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button color="primary" (click)="onConfirm()">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
